import { ReactNode } from 'react'

import HomCameraCircleIcon from '~/components/Icons/svgs/HomCameraCircleIcon'
import HomClockIcon from '~/components/Icons/svgs/HomClockIcon'
import HomGraduationCapCircleIcon from '~/components/Icons/svgs/HomGraduationCapCircleIcon'
import SVGIcon from '~/components/Icons/svgs/SVGIcon'
import { IconName } from '~/components/Icons/types'

export default function PanelElementContainer({
  children,
  className = '',
  header,
  headerIcon,
}: {
  children?: ReactNode
  className?: string
  header?: ReactNode
  headerIcon?: IconName
}): React.ReactElement {
  const getIconComponent = (name: string): ((props: { [key: string]: any }) => React.ReactElement) => {
    switch (name) {
      case 'hom-graduation-cap-circle':
        return HomGraduationCapCircleIcon
      case 'hom-camera-circle':
        return HomCameraCircleIcon
      default:
        return HomClockIcon
    }
  }
  return (
    <div className={`p-4 rounded shadow-large bg-white ${className}`}>
      {header && (
        <header className="space-x-1 flex items-center font-semibold">
          {headerIcon && <SVGIcon icon={getIconComponent(headerIcon)} size={24} />} <span>{header}</span>
        </header>
      )}
      {children}
    </div>
  )
}
